export const SET_ACTIVE_TRIGGERS_ONLY_SELECTED_THEMATICS = 'SET_ACTIVE_TRIGGERS_ONLY_SELECTED_THEMATICS';

export const setActiveTriggersOnlySelectedThematics = (onlySelectedThematicsSwitch: boolean) => ({
  type: SET_ACTIVE_TRIGGERS_ONLY_SELECTED_THEMATICS,
  data: onlySelectedThematicsSwitch,
});
